module.exports = __webpack_public_path__ + "static/media/ic-print.02264058.svg";